import { rem } from 'polished';
import styled from 'styled-components';

export const StyledListingsFilter = styled.div`
  padding: ${rem('24px')};
  border-radius: ${'16px'};
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  margin-top: ${rem('24px')};

  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${rem('16px')};
  }
`;

export const StyledListingsFilterTitle = styled.p`
  margin: 0;
  font-size: ${rem('18px')};
  font-weight: 700;
`;

export const StyledListingsFilterMultiCheckboxWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem('16px')};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    width: 100%;
    gap: ${rem('8px')};
  }
`;
